export const users = [
  { id: 1, name: 'Sarah Chen', avatar: 'https://i.pravatar.cc/150?img=1' },
  { id: 2, name: 'Alex Johnson', avatar: 'https://i.pravatar.cc/150?img=2' },
  { id: 3, name: 'Emma Wilson', avatar: 'https://i.pravatar.cc/150?img=3' },
  { id: 4, name: 'Michael Brown', avatar: 'https://i.pravatar.cc/150?img=4' },
  { id: 5, name: 'Lisa Davis', avatar: 'https://i.pravatar.cc/150?img=5' },
  { id: 6, name: 'James Miller', avatar: 'https://i.pravatar.cc/150?img=6' },
];

export const initialTasks = [
  {
    id: '1',
    title: 'SFR',
    contractNumber: '#1939951',
    agent: 'D. MICKAEL',
    clientName: 'ARREAU',
    contactName: 'DYLAN ROLIN',
    startTime: '10:06',
    endTime: '10:08',
    status: 'attente',
    statusColor: 'red',
    contractStatus: 'CONTRAT NON RÉALISABLE',
    contractReason: 'Autre... - Adresse incomplète',
    fullAddress: '1605,Route de la côte quartiers maison iratchetenia',
    hasCall: true,
    isLocked: true,
    subtasks: { completed: 3, total: 5 },
    assignees: [1, 2],
    attachments: 0,
    comments: 0,
    description: 'Contrat SFR non réalisable',
  },
  {
    id: '2',
    title: 'BOUYGUES',
    contractNumber: '#1939952',
    agent: 'M. SOPHIE',
    clientName: 'MARTIN',
    contactName: 'LUCAS BERNARD',
    startTime: '11:15',
    endTime: '11:20',
    status: 'attente',
    statusColor: 'green',
    contractStatus: 'EN COURS',
    contractReason: 'Validation en attente',
    fullAddress: '25 Avenue des Champs, Paris 75008',
    hasCall: true,
    isLocked: false,
    subtasks: { completed: 0, total: 1 },
    assignees: [3],
    attachments: 1,
    comments: 0,
    description: 'Contrat Bouygues en cours de validation',
  },
  {
    id: '3',
    title: 'ORANGE',
    contractNumber: '#1939953',
    agent: 'L. CAROLINE',
    clientName: 'DUBOIS',
    contactName: 'MARIE PETIT',
    startTime: '09:30',
    endTime: '09:45',
    status: 'attente',
    statusColor: 'blue',
    contractStatus: 'VALIDATION REQUISE',
    contractReason: 'Documents manquants',
    fullAddress: '15 Rue de la République, Lyon 69001',
    hasCall: true,
    isLocked: false,
    subtasks: { completed: 0, total: 2 },
    assignees: [4, 5, 6],
    attachments: 0,
    comments: 0,
    description: 'Contrat Orange - documents à fournir',
  },
  {
    id: '4',
    title: 'FREE',
    contractNumber: '#1939954',
    agent: 'P. THOMAS',
    clientName: 'MOREAU',
    contactName: 'JULIEN BLANC',
    startTime: '14:20',
    endTime: '14:35',
    status: 'attente',
    statusColor: 'gray',
    contractStatus: 'EN ATTENTE',
    contractReason: 'Client non joignable',
    fullAddress: '8 Boulevard Saint-Michel, Marseille 13008',
    hasCall: false,
    isLocked: true,
    subtasks: { completed: 0, total: 3 },
    assignees: [1, 2],
    attachments: 0,
    comments: 0,
    description: 'Contrat Free en attente de contact client',
  },
  {
    id: '5',
    title: 'RED BY SFR',
    contractNumber: '#1939955',
    agent: 'A. MARIE',
    clientName: 'LEROY',
    contactName: 'NICOLAS DURAND',
    startTime: '16:00',
    endTime: '16:15',
    status: 'contrevisite',
    statusColor: 'yellow',
    contractStatus: 'À VALIDER',
    contractReason: 'RIB à mettre à jour',
    fullAddress: '42 Rue Victor Hugo, Toulouse 31000',
    hasCall: true,
    isLocked: false,
    subtasks: { completed: 0, total: 4 },
    assignees: [6],
    attachments: 0,
    comments: 0,
    description: 'Contrat RED by SFR nécessite mise à jour RIB',
  },
  {
    id: '6',
    title: 'SFR',
    contractNumber: '#1939956',
    agent: 'R. DAVID',
    clientName: 'GARNIER',
    contactName: 'SOPHIE LAURENT',
    startTime: '10:30',
    endTime: '10:50',
    status: 'encours',
    statusColor: 'red',
    contractStatus: 'EN COURS DE TRAITEMENT',
    contractReason: 'Vérification technique',
    fullAddress: '23 Avenue Foch, Nice 06000',
    hasCall: true,
    isLocked: false,
    subtasks: { completed: 1, total: 3 },
    assignees: [1, 2],
    attachments: 0,
    comments: 0,
    description: 'Contrat SFR en cours de vérification',
  },
  {
    id: '7',
    title: 'BOUYGUES',
    contractNumber: '#1939957',
    agent: 'C. ISABELLE',
    clientName: 'ROUX',
    contactName: 'PIERRE GIRARD',
    startTime: '11:00',
    endTime: '11:15',
    status: 'encours',
    statusColor: 'green',
    contractStatus: 'VALIDATION EN COURS',
    contractReason: 'Attente confirmation',
    fullAddress: '5 Rue des Lilas, Nantes 44000',
    hasCall: false,
    isLocked: true,
    subtasks: { completed: 0, total: 2 },
    assignees: [3],
    attachments: 0,
    comments: 0,
    description: 'Contrat Bouygues en attente de confirmation',
  },
  {
    id: '8',
    title: 'ORANGE',
    contractNumber: '#1939958',
    agent: 'B. LAURENT',
    clientName: 'FAURE',
    contactName: 'ÉMILIE MOREL',
    startTime: '13:30',
    endTime: '13:45',
    status: 'encours',
    statusColor: 'yellow',
    contractStatus: 'TRAITEMENT FINAL',
    contractReason: 'Dernières vérifications',
    fullAddress: '18 Place de la République, Strasbourg 67000',
    hasCall: true,
    isLocked: false,
    subtasks: { completed: 0, total: 5 },
    assignees: [4, 5, 6],
    attachments: 0,
    comments: 0,
    description: 'Contrat Orange en phase finale',
  },
  {
    id: '9',
    title: 'FREE',
    contractNumber: '#1939959',
    agent: 'M. FRANÇOIS',
    clientName: 'LAMBERT',
    contactName: 'CLAIRE MARTINEZ',
    startTime: '08:00',
    endTime: '08:20',
    status: 'valides',
    statusColor: 'yellow',
    contractStatus: 'CONTRAT RÉALISÉ',
    contractReason: 'Signature effectuée',
    fullAddress: '10 Rue Pasteur, Bordeaux 33000',
    hasCall: false,
    isLocked: true,
    subtasks: { completed: 7, total: 7 },
    assignees: [1, 2, 3],
    attachments: 0,
    comments: 0,
    description: 'Contrat Free finalisé avec succès',
  },
  {
    id: '10',
    title: 'SFR',
    contractNumber: '#1939960',
    agent: 'N. JULIE',
    clientName: 'ROUSSEAU',
    contactName: 'MAXIME ROBERT',
    startTime: '09:15',
    endTime: '09:30',
    status: 'valides',
    statusColor: 'green',
    contractStatus: 'VALIDÉ',
    contractReason: 'Tous documents OK',
    fullAddress: '30 Boulevard Gambetta, Lille 59000',
    hasCall: true,
    isLocked: false,
    subtasks: { completed: 2, total: 2 },
    assignees: [4, 5],
    attachments: 1,
    comments: 0,
    description: 'Contrat SFR validé et signé',
  },
  {
    id: '11',
    title: 'ORANGE',
    contractNumber: '#1939961',
    agent: 'S. PATRICK',
    clientName: 'VINCENT',
    contactName: 'CAMILLE SIMON',
    startTime: '15:00',
    endTime: '15:20',
    status: 'sav',
    statusColor: 'gray',
    contractStatus: 'FINALISÉ',
    contractReason: 'Activation programmée',
    fullAddress: '12 Rue Jean Jaurès, Rennes 35000',
    hasCall: false,
    isLocked: false,
    subtasks: { completed: 2, total: 2 },
    assignees: [6, 1],
    attachments: 0,
    comments: 0,
    description: 'Contrat Orange terminé',
  },
  {
    id: '12',
    title: 'BOUYGUES',
    contractNumber: '#1939962',
    agent: 'V. SANDRINE',
    clientName: 'FOURNIER',
    contactName: 'LUCAS THOMAS',
    startTime: '12:00',
    endTime: '12:15',
    status: 'livres',
    statusColor: 'blue',
    contractStatus: 'ACTIVÉ',
    contractReason: 'Service en ligne',
    fullAddress: '7 Place du Marché, Montpellier 34000',
    hasCall: true,
    isLocked: true,
    subtasks: { completed: 1, total: 1 },
    assignees: [2],
    attachments: 0,
    comments: 0,
    description: 'Contrat Bouygues activé',
  },
  {
    id: '13',
    title: 'RED BY SFR',
    contractNumber: '#1939963',
    agent: 'G. OLIVIER',
    clientName: 'MERCIER',
    contactName: 'SARAH BONNET',
    startTime: '14:45',
    endTime: '15:00',
    status: 'livres',
    statusColor: 'red',
    contractStatus: 'LIVRÉ',
    contractReason: 'Box installée',
    fullAddress: '45 Avenue de la Liberté, Grenoble 38000',
    hasCall: false,
    isLocked: false,
    subtasks: { completed: 4, total: 4 },
    assignees: [3, 4],
    attachments: 1,
    comments: 0,
    description: 'Contrat RED by SFR livré et installé',
  },
];

export const projects = [
  { id: 1, name: 'Sales Forecast', icon: '📊', count: 2, color: '#8b5cf6' },
  { id: 2, name: 'Sentiment AI', icon: '⚡', count: 7, color: '#f59e0b' },
  { id: 3, name: 'Task Automate', icon: '🤖', count: 18, color: '#3b82f6', active: true },
  { id: 4, name: 'Script AI', icon: '⚡', count: 3, color: '#eab308' },
  { id: 5, name: 'Lead Scoring', icon: '🎯', count: 15, color: '#6366f1' },
  { id: 6, name: 'Heatmap AI', icon: '🔥', count: 6, color: '#ef4444' },
  { id: 7, name: 'Social Boost', icon: '📱', count: 9, color: '#06b6d4' },
];

export const categories = [
  { id: 1, name: 'Marketing AI', icon: '#', color: '#a855f7' },
  { id: 2, name: 'Chatbots', icon: '#', color: '#06b6d4' },
  { id: 3, name: 'Finance AI', icon: '#', color: '#d946ef' },
];

export const favorites = [
  { id: 1, name: 'AI Writer', icon: '✏️', color: '#ef4444' },
  { id: 2, name: 'Data Insights', icon: '📊', color: '#3b82f6' },
  { id: 3, name: 'Predictive AI', icon: '💡', color: '#f59e0b' },
];